module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_nice-aa8917374fa18399812294523f90664f.svg";